// The API answers 503 with this code while in maintenance (koob-api
// src/app/http/Maintenance.ts): writes only in read-only mode, every request
// once closed.
export const MAINTENANCE_EVENT = 'koob:maintenance';

export const isMaintenanceError = (error) =>
  error?.response?.status === 503 &&
  error?.response?.data?.code === 'MAINTENANCE';

// Called by each app's axios interceptor: KoobMaintenanceGate reads the status
// again at once instead of waiting for its next poll.
export const reportMaintenance = (error) => {
  if (isMaintenanceError(error)) {
    window.dispatchEvent(new Event(MAINTENANCE_EVENT));
  }
};
